import script from "./DirectoryLogosCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectoryLogosCarousel.vue?vue&type=script&setup=true&lang=js"

import "./DirectoryLogosCarousel.vue?vue&type=style&index=0&id=6f315fda&lang=css"

const __exports__ = script;

export default __exports__